import html from "./ConsentSurveyContainer.html"
import "../SurveyManager.js"
import "./SurveyModal.js"
import moment from 'moment-timezone';
import { persistConsentResult, persistLinkConsentResult } from "../../../api/survey/surveyResult";
import { deleteConsentRestorationData, getConsentRestorationData } from '../../../api/survey/restorationData';
import { getSurveyPlatforms } from '../../../helpers/surveyPlatformCompatibility';

var module = angular.module("ResearchKitApplicationModule");

module.component('consentSurveyContainer', {
	template: html,
	bindings: {
		projectId: '<',
		identifier: '<',
		linkKey: '<',
		consentTaskModel: '<',
		confirmationMessage: '<'
	},
	controller: 'consentSurveyContainerController',
	controllerAs: 'vm'
});

module.controller("consentSurveyContainerController", ["$scope", "$http", "ceUrl", "surveyManagerFactory", "$translate",
	function ($scope, $http, ceUrl, surveyManagerFactory, $translate) {
		var vm = this;

		function surveyFinished(reason) {
			var result = vm.surveyManager.getResult();
			var completionAction = vm.surveyManager.getCompletionAction();
			if (reason === "Completed") {
				$scope.$emit("surveyFinished", reason, result, completionAction);
			} else {
				$scope.$emit("surveyFinished", reason);
			}
			vm.surveyManager = null;
			vm.platforms = null;
		}

		function surveySaveFailed(error) {
			$translate('survey-submit-error').then(function (translatedValue) {
				alert(translatedValue);
			}).then(function () {
				$scope.$emit("surveyFinished", "Failed");
				vm.surveyManager = null;
				vm.platforms = null;
			});
		}

		function saveResults(reason) {
			// For required survey mode; ensures that an untrusted org cannot just send a link with a 0-step survey 
			// to join someone to a project
			if (vm.confirmationMessage && !window.confirm(vm.confirmationMessage)) {
				ActiveLogout.Logout(true);
				return;
			}
			var result = vm.surveyManager.getResult();
			if (vm.linkKey) {
				return persistLinkConsentResult(vm.linkKey, result);
			} else {
				return persistConsentResult(vm.projectId, result, vm.identifier);
			}
		}

		function getConsent(changesObj) {
			if (changesObj.consentTaskModel && changesObj.consentTaskModel.currentValue) {
				return Promise.resolve({ data: changesObj.consentTaskModel.currentValue });
			} else if (changesObj.linkKey?.currentValue) {
				var url = "api/researchkit/studyenrollment/consent/" + changesObj.linkKey.currentValue;
				return $http.get(ceUrl.make(url));
			} else {
				var url = "api/researchkit/studyenrollment/studies/" + changesObj.projectId.currentValue + "/consent?offset=" + encodeURIComponent(moment().format("Z"));
				if (vm.identifier) {
					url += "&identifier=" + encodeURIComponent(vm.identifier);
				}
				return $http.get(ceUrl.make(url));
			}
		}

		this.$onChanges = function (changesObj) {
			$scope.loading = true;
			if (changesObj.projectId?.currentValue ||
				changesObj.linkKey?.currentValue) {
				Promise.all([getConsent(changesObj), getConsentRestorationData(changesObj.projectId?.currentValue, changesObj.linkKey?.currentValue)])
					.then(([response, restorationData]) => {
						var result = response.data;
						$translate('continue-consent-survey')
							.then(function (translatedValue) {
								if (restorationData && (restorationData.templateVersion !== result.Version || !confirm(translatedValue))) {
									restorationData = null;
									deleteConsentRestorationData(result.ProjectID);
								}
								vm.platforms = getSurveyPlatforms(result.Template);
								if (vm.platforms.indexOf("Web") === -1) return;
								vm.surveyManager = surveyManagerFactory.createSurveyManager({
									participantID: result.ParticipantID,
									surveyID: result.SurveyID,
									surveySessionID: result.SurveySessionID,
									template: result.Template,
									templateVersion: result.Version,
									participantStateAudit: result.ParticipantStateAudit,
									finishedCallback: surveyFinished,
									saveResultsCallback: saveResults,
									saveResultsErrorCallback: surveySaveFailed,
									projectRecordAuthorityCode: result.ProjectRecordAuthorityCode,
									projectID: result.ProjectID,
									restorationData: restorationData,
									expressionInputs: result.ExpressionInputs
								}, {
									mode: "Survey",
									isCoordinatorEntered: false,
									analyticsEnabled: true,
									context: "Consent"
								});

								$scope.loading = false;
								if (result.SurveyPreviouslyCompleted) {
									vm.surveyManager.endAndComplete();
								} else {
									vm.surveyManager.startSurvey();
								}
							});
					});
			}
		};
	}]);
